import { render, staticRenderFns } from "./DevopsDept.vue?vue&type=template&id=5b6623c6&scoped=true&"
import script from "./DevopsDept.vue?vue&type=script&lang=js&"
export * from "./DevopsDept.vue?vue&type=script&lang=js&"
import style0 from "./DevopsDept.vue?vue&type=style&index=0&id=5b6623c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6623c6",
  null
  
)

export default component.exports